export const DateUtils = {
  format(date: Date | string, format: string = 'DD.MM.YYYY'): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    if (format === 'DD.MM.YYYY') {
      return `${day}.${month}.${year}`;
    }
    if (format === 'DD.MM.YYYY HH:mm') {
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    }
    if (format === 'YYYY-MM-DD') {
      return `${year}-${month}-${day}`;
    }

    return `${day}.${month}.${year}`;
  },

  from1C(str: string | null | undefined): Date | null {
    if (!str || str.length !== 14) return null;
    return new Date(
      parseInt(str.substring(0, 4)),
      parseInt(str.substring(4, 6)) - 1,
      parseInt(str.substring(6, 2)),
      parseInt(str.substring(8, 2)) || 0,
      parseInt(str.substring(10, 2)) || 0,
      parseInt(str.substring(12, 2)) || 0
    );
  },

  to1C(date: Date): string {
    const pad = (n: number): string => String(n).padStart(2, '0');
    return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
  },

  diff(date1: Date | string, date2: Date | string = new Date()): number {
    return Math.floor((new Date(date1).getTime() - new Date(date2).getTime()) / 1000);
  },

  secondsToString(seconds: number, depth: number = 4): string {
    const plural = (n: number, forms: [string, string, string]): string => {
      const last = n % 10;
      const last2 = n % 100;
      if (last2 >= 11 && last2 <= 19) return forms[0];
      if (last === 1) return forms[1];
      if (last >= 2 && last <= 4) return forms[2];
      return forms[0];
    };

    const parts: string[] = [];
    let remaining = seconds;

    const days = Math.floor(remaining / 86400);
    if (days > 0 && depth > 0) {
      parts.push(`${days}${plural(days, [' дней ', ' день ', ' дня '])}`);
      remaining -= days * 86400;
    }

    const hours = Math.floor(remaining / 3600);
    if (hours > 0 && depth > 1) {
      parts.push(`${hours}${plural(hours, [' часов ', ' час ', ' часа '])}`);
      remaining -= hours * 3600;
    }

    const minutes = Math.floor(remaining / 60);
    if (minutes > 0 && depth > 2) {
      parts.push(`${minutes}${plural(minutes, [' минут ', ' минуту ', ' минуты '])}`);
      remaining -= minutes * 60;
    }

    if (remaining > 0 && depth > 3) {
      parts.push(`${remaining}${plural(remaining, [' секунд', ' секунда', ' секунды'])}`);
    }

    return parts.join('');
  },
};
